import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandingService } from '@next/core-lib/branding';
import { RouterSelectors } from '@next/core-lib/router-store';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { take, filter } from 'rxjs/operators';

import { listAnimations } from '../../../../animations';
import { Customer, CustomerLocation, SiteState } from '../../../../shared/models/shared.model';
import {
  deleteLocationWithConfirmation,
  getLocationsRequest,
} from '../../../store/customer.actions';
import {
  getLocationsForCustomer,
  getSelectedCustomerId,
  getSelectedCustomer,
} from '../../../store/customer.selectors';

@Component({
  selector: 'app-customer-locations',
  templateUrl: './customer-locations.component.html',
  styleUrls: ['./customer-locations.component.scss'],
  animations: [listAnimations],
  standalone: false,
})
export class CustomerLocationsComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly brandingService = inject(BrandingService);

  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getUrl));

  customerId$: Observable<number> = this.store.select(getSelectedCustomerId);
  customer$: Observable<Customer> = this.store.select(getSelectedCustomer).pipe(
    filter((customer) => !!customer && !!customer.id),
    take(1),
  );
  locations$: Observable<CustomerLocation[]> = this.store.select(getLocationsForCustomer);

  customerSubscription: Subscription;
  isAgrifirm: boolean = this.brandingService.isTenant('Agrifirm');

  ngOnInit() {
    this.customerSubscription = this.customer$.subscribe((customer) => {
      if (customer?.id) {
        this.store.dispatch(getLocationsRequest({ customerId: customer.id }));
      }
    });
  }

  ngOnDestroy(): void {
    if (this.customerSubscription) {
      this.customerSubscription.unsubscribe();
    }
  }

  add = () => this.router.navigate(['add'], { relativeTo: this.activatedRoute });

  delete(event: Event, id: number) {
    event.preventDefault();
    event.stopImmediatePropagation();

    this.store.dispatch(deleteLocationWithConfirmation({ id }));
  }
}
